import CONSTANTS from '../constants';
import AppService from "./appService";
import CacheService from './cacheService';
import axios from 'axios';

export default {
    createAppointment,
    getSchedule,
    getAppointment,
    getAppointments,
    bookMemberToAppointment
};

async function createAppointment(data) {
    let newAccessToken = await AppService.refreshAccessToken();
    return axios.post(`${CONSTANTS.URLS.ROOT}${CONSTANTS.URLS.END_POINTS.APPOINTMENTS}`, data, {
        headers: {
            'Business-Name': CacheService.getToken().bname,
            'Access-Token': newAccessToken
        }});
}

function getSchedule(businessName, params) {
    return axios.get(`${CONSTANTS.URLS.ROOT}${CONSTANTS.URLS.END_POINTS.APPOINTMENTS}/schedule`, {
        params: params,
        headers: {
            'Business-Name': businessName,
            'Skip-Load-Resource': true
        }});
}

async function getAppointment(appointmentId) {
    let newAccessToken = await AppService.refreshAccessToken();
    return axios.get(`${CONSTANTS.URLS.ROOT}${CONSTANTS.URLS.END_POINTS.APPOINTMENTS}/${appointmentId}`, {
        headers: {
            'Business-Name': CacheService.getToken().bname,
            'Access-Token': newAccessToken
        }});
}

async function getAppointments(params) {
    let newAccessToken = await AppService.refreshAccessToken();
    return axios.get(`${CONSTANTS.URLS.ROOT}${CONSTANTS.URLS.END_POINTS.APPOINTMENTS}/`, {
        params: params,
        headers: {
            'Business-Name': CacheService.getToken().bname,
            'Access-Token': newAccessToken
        }});
}

async function bookMemberToAppointment(appointmentId) {
    let newAccessToken = await AppService.refreshAccessToken();
    return axios.post(`${CONSTANTS.URLS.ROOT}${CONSTANTS.URLS.END_POINTS.APPOINTMENTS}/${appointmentId}/book`, {}, {
        headers: {
            'Business-Name': CacheService.getToken().bname,
            'Access-Token': newAccessToken
        }});
}



// WEBPACK FOOTER //
// ./src/services/appointmentService.js